import { Component } from '@angular/core';
import { LayoutService, MenuItem } from '@common/services/layout.service';

@Component({
  selector: 'sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {

  constructor(public layout: LayoutService) {
  }

  displayable(item: MenuItem) {
    return typeof item.condition !== 'function' || item.condition();
  }
}
